export type PartyRoleFilter = "" | "client" | "referrer";
export type PartyViewMode = "table" | "grid";

export const ALL_ROLE_FILTER_VALUE = "__all__";

export const PARTIES_PAGE_GUIDE = [
  "Recherchez une partie par nom, téléphone, email ou code.",
  "Filtrez par rôle (client/référent) ou par statut (actif/inactif).",
  "Cliquez sur « Nouvelle partie » pour en créer une.",
  "Cliquez sur une ligne pour ouvrir sa fiche détail.",
];
